/** Only surface field-group validation messages after the user has attempted submit. */
export function fieldErrorsAfterSubmit<
  T extends Record<string, string | undefined>,
>(errors: T, hasAttemptedFormSubmission: boolean): T {
  if (hasAttemptedFormSubmission) {
    return errors;
  }

  return {} as T;
}

/** Same as fieldErrorsAfterSubmit but returns a strict Record<string, string> for field groups. */
export function fieldErrorsAfterSubmitRecord<
  T extends Record<string, string | undefined>,
>(errors: T, hasAttemptedFormSubmission: boolean): Record<string, string> {
  const gated = fieldErrorsAfterSubmit(errors, hasAttemptedFormSubmission);

  return Object.fromEntries(
    Object.entries(gated).filter(([, value]) => value !== undefined),
  ) as Record<string, string>;
}
